import { createContext, useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Pages/Auth/Login"
import Register from "Pages/Auth/Register";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider, useAuth } from "./context/AuthContext";
import BackgroundInitializer from "./components/BackgroundInitializer";
import { InitializationProvider } from "./context/InitializationContext";
import { ThemeProvider } from "./context/ThemeContext";
import SplineEditor from "./components/SplineEditor";
import ApiProvider from "./context/ApiProvider";
import MainApp from "Pages/MainApp/MainApp";
import AdminPage from "Pages/Admin/AdminPage";
import ExhibitionEntry from "Pages/Exhibition/ExhibitionEntry";


interface WorkerContextType {
  worker: Worker | null;
}

export const WorkerContext = createContext<WorkerContextType>({ worker: null });

export const useWorker = () => useContext(WorkerContext);

function AppRoutes() {
  const { isAuthenticated, isAuthReady, isExhibition, user } = useAuth();

  if (!isAuthReady) return null;

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/exhibition"
          element={<ExhibitionEntry />}
        />
        <Route
          path="/exhibition/demo"
          element={isAuthenticated && isExhibition ? <MainApp /> : <Navigate to="/exhibition" replace />}
        />
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Login />
            )
          }
        />
        <Route
          path="/register"
          element={<Register />}
        />
        <Route
          path="/"
          element={
            localStorage.getItem('accessToken') ?
              <MainApp /> : <Login />
          }
        />
        <Route
          path="/admin"
          element={
            !localStorage.getItem('accessToken') ? (
              <Login />
            ) : user?.isAdmin ? (
              <AdminPage />
            ) : user ? (
              <Navigate to="/" replace />
            ) : (
              // Session restore in progress (token exists, user not hydrated yet)
              null
            )
          }
        />
        <Route
          path="/spline-editor"
          element={
            <ProtectedRoute>
              <div className="spline-editor-container">
                <SplineEditor />
              </div>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ApiProvider>
            <InitializationProvider>
              <BackgroundInitializer>
                <AppRoutes />
              </BackgroundInitializer>
            </InitializationProvider>
        </ApiProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
